import { useI18n } from '@cascade/react/i18n';
import { ProjectGate as SharedProjectGate } from '@cascade/react/projects';
import type { PropsWithChildren } from 'react';
import { Layout } from '#layout/index.ts';
import { NoProjects } from '#views/no-projects/index.ts';
import { ProjectsFailed } from '#views/projects-failed/index.ts';
import { SelectProject } from '#views/select-project/index.ts';

export const ProjectGate = ({ children }: PropsWithChildren) => {
  const { translate } = useI18n();

  return (
    <SharedProjectGate
      loading={
        <Layout mode='card' title={translate('pending.projects')} isLoading />
      }
      failed={<ProjectsFailed />}
      none={<NoProjects />}
      unselected={<SelectProject />}
    >
      {children}
    </SharedProjectGate>
  );
};
